import { useLocation } from "react-router-dom"
import { ReadMore } from "../components/readMore"

export const ReadMorePage = () => {
    const location = useLocation();
   const data = location.state.data;
    return (<ReadMore data={data}/>)
}